// extracted by mini-css-extract-plugin
export default {"media-history":"media-history--qe-vGzWQ56","mediaHistory":"media-history--qe-vGzWQ56"};